import {
  OFFER_STEP,
  ASSUMED_GAMEPLAY_DURATION,
  GAMEPLAY_ATTACHMENT_TYPES,
} from "./gameplay-analysis.constants"
import { GAME_CODE_LABEL } from "@/store/game/game.constants"
import { COACH_PLATFORM_FEE } from "@/store/coach/coach.constants"

export const formatValidOfferStepAmount = amount => {
  return Math.ceil(amount / OFFER_STEP) * OFFER_STEP
}

export const getGpaRequestEstimatedDurationInSeconds = gpaRequest => {
  const attachmentInfo = gpaRequest.async_param.commentaries[0] || null
  const attachmentType = attachmentInfo?.vod_type || GAMEPLAY_ATTACHMENT_TYPES.UNKNOWN
  const attachmentMetadata = attachmentInfo?.attachment_metadata || null

  switch (attachmentType) {
    case GAMEPLAY_ATTACHMENT_TYPES.FILE_ATTACHMENT:
      return attachmentMetadata?.video_duration || null
    case GAMEPLAY_ATTACHMENT_TYPES.REPLAY_REFERENCE:
      return attachmentMetadata?.replay_duration || null
  }
  return null
}

export const calculateEffectiveHourlyPay = gpaRequest => {
  const defaultPriceInUsd = gpaRequest.async_param?.request?.session_type_async_subject.default_price || 0
  const offerAmountInUsd = gpaRequest.offered_amount !== null
    ? (gpaRequest.offered_amount / 100)
    : null
  const amountPaidInUsd = offerAmountInUsd || defaultPriceInUsd
  const payoutInUsd = amountPaidInUsd * (1 - COACH_PLATFORM_FEE)
  const durationInSeconds = getGpaRequestEstimatedDurationInSeconds(gpaRequest) || ASSUMED_GAMEPLAY_DURATION
  return durationInSeconds ? (payoutInUsd / (durationInSeconds / 3600)) : 0
}

export const checkGameReplayCodeSupport = gameKey => {
  const codeEnabledGames = Object.keys(GAME_CODE_LABEL)
  return codeEnabledGames.includes(gameKey)
}



// WEBPACK FOOTER //
// ./src/store/coaching/gameplay-analysis/gameplay-analysis.utils.js